import styled, { css } from 'styled-components';
import { GradientText } from './navbar.style';
import { breakpoints } from '../../../styles/screenSizes';

export const SharedButtonStyle = css`
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    border-radius: 8px;
    padding: 10px 24px;
    border: 1px solid #0074fc;
    cursor: pointer;

    @media (max-width: ${breakpoints.md}) {
        font-size: 14px;
        padding: 7px 21px;
        border-radius: 5px;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: ${breakpoints.md}) {
        justify-content: flex-end;
        flex-direction: row-reverse;
        padding: 0 24px;
    }
`;

export const SecondaryButton = styled.button`
    all: unset;
    ${SharedButtonStyle}
    ${GradientText}
     transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.05);
    }
`;

export const PrimaryButton = styled.a`
    ${SharedButtonStyle}
    position: relative;
    background: linear-gradient(96.28deg, #0c1a68 0%, #0074fc 100%);
    color: #fff;
    overflow: hidden;
    z-index: 1;
    text-decoration: none;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(96.28deg, #0074fc 0%, #0c1a68 100%);
        opacity: 0;
        transition: opacity 0.4s ease;
        z-index: -1;
    }

    &:hover::before {
        opacity: 1;
    }
`;
